import cardSlider from "../../shared/welcome/cardSlider";
import japanMap from "../../shared/welcome/japanMap";
import videoCardHover from "../../shared/videoCardHover";

export default () => {
  cardSlider();
  japanMap();
  videoCardHover();
};
